/**
 * Toggle Controls Module
 * Controls for toggling garden bed styles and square foot information
 */

// Variables to track toggle states
let isCurvedBorder = false; // Start with default border radius (10px)
let showSquareFootInfo = true; // Start with square foot info visible
let isInGroundBed = false; // Start with raised bed style so first click shows raised bed

// Function to initialize toggle controls
export function initializeToggleControls() {
    // Get references to the toggle buttons
    const borderRadiusToggleBtn = document.getElementById('toggle-border-radius-btn');
    const squareFootToggleBtn = document.getElementById('toggle-square-foot-btn');
    const bedStyleToggleBtn = document.getElementById('toggle-bed-style-btn');
    
    // Add event listener for border radius toggle
    if (borderRadiusToggleBtn) {
        borderRadiusToggleBtn.addEventListener('click', toggleBorderRadius);
    }
    
    // Add event listener for square foot info toggle
    if (squareFootToggleBtn) {
        squareFootToggleBtn.addEventListener('click', toggleSquareFootInfo);
    }

    // Add event listener for bed style toggle
    if (bedStyleToggleBtn) {
        bedStyleToggleBtn.addEventListener('click', toggleBedStyle);
    }
    
    console.log('✅ Toggle controls initialized');
}

// Function to toggle border radius
function toggleBorderRadius() {
    // Get the grid container
    const gridContainer = document.getElementById('grid');
    
    if (!gridContainer) return;
    
    // Toggle the curved border state
    isCurvedBorder = !isCurvedBorder;
    
    // Apply the appropriate class
    if (isCurvedBorder) {
        gridContainer.classList.add('curved');
        this.innerHTML = '<i class="fa fa-square-o"></i> Wooden Raised Beds';
    } else {
        gridContainer.classList.remove('curved');
        this.innerHTML = '<i class="fa fa-square-o"></i> Curved Metal Beds';
    }
}

// Function to toggle square foot information
function toggleSquareFootInfo() {
    // Toggle the state
    showSquareFootInfo = !showSquareFootInfo;
    
    // Get all plants-per-sqft elements
    const sqftInfoElements = document.querySelectorAll('.plants-per-sqft');
    
    // Toggle visibility for all square foot info elements
    sqftInfoElements.forEach(element => {
        element.style.display = showSquareFootInfo ? 'block' : 'none';
    });
    
    // Update the button text
    if (showSquareFootInfo) {
        this.innerHTML = '<i class="fa fa-th"></i> Hide SFG Info';
    } else {
        this.innerHTML = '<i class="fa fa-th"></i> Show SFG Info';
    }
}

// function to change to inground gardening
function toggleBedStyle() {
    // Get the grid container
    const gridContainer = document.getElementById('grid');
    
    if (!gridContainer) {
        console.error('Grid container not found');
        return;
    }
    
    // Toggle the bed style state
    isInGroundBed = !isInGroundBed;
    console.log('Bed style toggled:', isInGroundBed ? 'in-ground' : 'raised');
    
    if (isInGroundBed) {
        console.log('Applying in-ground style');
        gridContainer.classList.remove('raised');
        gridContainer.classList.add('in-ground');
        this.innerHTML = '<i class="fa fa-leaf"></i> Raised Bed';
    } else {
        gridContainer.classList.remove('in-ground');
        gridContainer.classList.add('raised');
        this.innerHTML = '<i class="fa fa-leaf"></i> In-Ground Bed';
    }
}

// Export additional functions that might be needed by other modules
export { toggleBorderRadius, toggleSquareFootInfo, toggleBedStyle }; 